<ng-template #loading>
  <!-- <mat-spinner [diameter]="60" [strokeWidth]="4" mode="indeterminate"></mat-spinner> -->
  <p class="status">{{ 'PRODUCT_LIST.LOADING_FROM_CACHE' | translate }}</p>
</ng-template>

<ng-template #refreshing>
  <!-- <mat-spinner [diameter]="60" [strokeWidth]="4" mode="indeterminate"></mat-spinner> -->
  <p class="status">{{ 'PRODUCT_LIST.LOADING_REFRESHING' | translate }}</p>
</ng-template>

<ng-container *ngIf="{ ready: !(loading$ | async) && !(refreshing$ | async), loading: loading$ | async, refreshing: refreshing$ | async, products: products$ | async } as state;">
  <ng-container *ngIf="!state.loading; else loading">
    <ng-container *ngIf="!state.refreshing || state.products?.length > 0; else refreshing">
      <mat-accordion multi="true" @blockInitialRenderAnimation [@.disabled]="disableAnimation">
        <app-product *ngFor="let productObservable of products$ | async; let even = even; let odd = odd; trackBy: trackByCode;" [product$]="productObservable.observable" [locale]="locale" [readOnly]="readOnly" [expandAll$]="expandAll$" [ngClass]="{ odd: odd, even: even }">
        </app-product>
      </mat-accordion>
      <p *ngIf="!state.products?.length" class="status">{{ 'SEARCH.LABEL_PRODUCTS_NO_RESULTS' | translate}}</p>
    </ng-container>
  </ng-container>
</ng-container>
